function fillWildcards(keyframes) {
    for (let i = 1; i < keyframes.length; i++) {
        keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
    }
}

export { fillWildcards };
//# sourceMappingURL=fill-wildcards.mjs.map
